import { Affix, Button } from "antd";
import { FC } from "react";
import {
  ParcelFormFooterActions,
  ParcelFormFooterBar,
} from "../../manageParcelLayout";

type ParcelFormFooterProps = {
  creating: boolean;
  /** ปลดล็อกแถบปุ่มเมื่อถึงขั้นที่ 4 (ที่อยู่ครบ) */
  sectionEnabled?: boolean;
  canCreate: boolean;
  onCreate: () => void;
};

const ParcelFormFooter: FC<ParcelFormFooterProps> = ({
  creating,
  sectionEnabled = true,
  canCreate,
  onCreate,
}) => {
  return (
    <Affix offsetBottom={0}>
      <ParcelFormFooterBar
        style={{
          opacity: sectionEnabled ? 1 : 0.55,
          pointerEvents: sectionEnabled ? "auto" : "none",
        }}
      >
        <ParcelFormFooterActions>
          <Button
            className="parcel-create-parcel-btn"
            loading={creating}
            disabled={!sectionEnabled || !canCreate}
            onClick={onCreate}
            style={{ minWidth: 200, backgroundColor: "#FFD700", borderColor: "#FFD700", color: "#000" }}
          >
            สร้างรายการส่งพัสดุ
          </Button>
        </ParcelFormFooterActions>
      </ParcelFormFooterBar>
    </Affix>
  );
};

export default ParcelFormFooter;
